import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Container, Icon } from "semantic-ui-react";

class UploadAttachmentEvent extends React.Component {
  static propTypes = {
    date: PropTypes.string,
    user: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { date, user, type, name } = this.props;

    return (
      <div data-component="timelineItem">
        <div className="bullet-pointer">
          <Icon color="grey" size="large" circular name="file outline" />
          <Icon color="green" name="plus" className="corner" />
        </div>
        <Container data-component="logDetails">
          <time>{date}</time>{" "}
          <FormattedMessage
            id="activity.timeline.event.uploadAttachment"
            defaultMessage="activity.timeline.event.uploadAttachment"
            values={{ type, name }}
          />
          <div className="user">{user}</div>
        </Container>
      </div>
    );
  }
}

export default UploadAttachmentEvent;
